import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useClickOutside from '@hooks/useClickOutside';

import { allFilterPages, formatRangeValue } from '@features/filter/static/filterUtil';
import Checkbox from '@features/filter/v2/Checkbox';
import FilterInput from '@features/filter/v2/FilterInput';
import FilterName from '@features/filter/v2/FilterName';

import { clearSelectedFilterName, storeItemInGlobalFilter } from '@store/actions/FilterAction';

const Composition = ({ filterPageName }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const { selectedCheckboxField } = useSelector((store) => store.slectedCheckBoxFieldStore);
	const [compositionInputValue, setCompositionInputValue] = useState({ min: '', max: '' });
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const multiLevelFilterStore = useSelector((store) => store.multiLevelFIlterStore);
	const currentSelectedFilterLevel = multiLevelFilterStore?.currentSelectedFilterLevel;
	const dispatch = useDispatch();
	const wrapperRef = useRef(null);
	const [activeLayer, setActiveLayer] = useState('');

	const onOutSideClick = () => {
		if (selectedCheckboxField === 'COMPOSITION') dispatch(clearSelectedFilterName());
	};

	useClickOutside(wrapperRef, onOutSideClick);

	useEffect(() => {
		setCompositionInputValue({ min: '', max: '' });
	}, [multiLevelFilterStore?.multiLevelFilters[1]?.name]);

	useEffect(() => {
		onFetchCompositionData();
	}, [dependentFilterList]);

	useEffect(() => {
		setData(allData);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.FABRIC_LIST_TAB]: dependentFilterList?.compositionList,
		[allFilterPages.COSTING_LIST]: dependentFilterList?.fiberList
	};

	const onFetchCompositionData = async () => {
		let responseData = filterData[filterPageName];
		responseData = responseData?.map((item, idx) => {
			return {
				id: `${idx}_${item?.name}`,
				name: item?.name,
				hasInputField: true,
				count: item?.count
			};
		});
		setAllData(responseData);
		setData(responseData);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allData?.filter((item) => item?.name?.toLowerCase().includes(e.target.value.toLowerCase()))
			: allData;
		setData(searchResult);
	};

	const onApplyChange = () => {
		let data = {
			name: 'fabricCompositionPartSearchDtoList',
			key: compositionInputValue,
			minPercentage: parseFloat(compositionInputValue.min),
			maxPercentage: parseFloat(compositionInputValue.max),
			fiberName: activeLayer,
			value: `${activeLayer}: ${formatRangeValue(compositionInputValue, '%')}`,
			identifier: activeLayer,
			type: 'COMPOSITION'
		};

		dispatch(storeItemInGlobalFilter(data));
		onClearInput();
		onOutSideClick();
	};

	const onClearInput = () => {
		setCompositionInputValue({ min: '', max: '' });
	};

	const onChangeComposition = (e) => {
		const { name, value } = e.target;
		setCompositionInputValue((prev) => ({
			...prev,
			[name]: value
		}));
	};

	const getActiveLebelName = (option) => {
		setActiveLayer(option?.name);
	};

	return (
		<div ref={wrapperRef}>
			<FilterName type="COMPOSITION" data={data} />
			<Checkbox
				data={data}
				type="COMPOSITION"
				handleSearch={handleSearch}
				nextFilterLevel={3}
				onSelectedOption={getActiveLebelName}
			/>

			{selectedField?.selectedCheckboxField === 'COMPOSITION' &&
				[3].includes(currentSelectedFilterLevel) && (
					<div className={`filter-submenu  scroll-y-label`} style={{ marginLeft: '235px' }}>
						<FilterInput
							onApplyHandler={onApplyChange}
							onChangeHandler={onChangeComposition}
							inputValue={compositionInputValue}
							placeHolderOne="Min %"
							placeHolderTwo="Max %"
							type="COMPOSITION"
							onClearInputFields={onClearInput}
						/>
					</div>
				)}
		</div>
	);
};

export default Composition;
